import { LinkedinLogo, ArrowUpRight, EnvelopeSimple } from "@phosphor-icons/react";
import { useLang } from "@/hooks/useLang";
import { Reveal } from "@/components/motion/Reveal";

export default function LeadMagnet({ profile }) {
  const { t } = useLang();
  if (!profile) return null;

  return (
    <section className="px-6 md:px-12 lg:px-20 py-16">
      <Reveal>
        <div
          data-testid="lead-magnet"
          className="relative overflow-hidden rounded-2xl border border-border bg-secondary/50 p-8 md:p-14"
        >
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />
          <span className="label-mono text-muted-foreground">{t("newsletter_name")}</span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-extrabold tracking-tight max-w-2xl">
            {t("newsletter_title")}
          </h2>
          <p className="mt-4 max-w-xl text-muted-foreground font-light leading-relaxed">
            {t("newsletter_text")}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="lead-magnet-newsletter"
              href={profile.linkedin_newsletter}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 rounded-md bg-primary px-6 py-3.5 text-primary-foreground font-medium transition-transform hover:scale-[1.03]"
            >
              <EnvelopeSimple weight="bold" size={20} />
              {t("newsletter_subscribe")}
              <ArrowUpRight weight="bold" size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              data-testid="lead-magnet-connect"
              href={profile.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 rounded-md border border-border px-6 py-3.5 font-medium transition-colors hover:border-primary hover:text-primary"
            >
              <LinkedinLogo weight="fill" size={20} />
              {t("newsletter_connect")}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
